import { formatDateTime } from '@pickleballinc/lib/format-dates';

import { isGameMakerMatch } from '@/modules/results/helpers';
import { Match } from '@/modules/results/types';

interface MatchHeaderProps {
  match?: Match;
}

function GameMakerHeader({ match }: { match: Match }) {
  const gameDayDate = match.module_start_date
    ? formatDateTime(match.module_start_date, { type: 'date', includeWeekday: true })
    : '';
  const subtitle = [match.module_sub_title, match.league_match_date_title]
    .filter(Boolean)
    .join(' · ');

  return (
    <>
      <h2 className='text-center text-xl font-bold text-white sm:text-3xl'>{match.module_title}</h2>
      {subtitle ? (
        <h3 className='my-1 text-center font-bold text-white sm:text-2xl'>{subtitle}</h3>
      ) : null}
      {gameDayDate ? (
        <p className='text-center text-sm text-white sm:text-base'>{gameDayDate}</p>
      ) : null}
    </>
  );
}

function MatchHeader({ match }: MatchHeaderProps) {
  return (
    <div
      className={`${match?.format_title === 'Singles' ? 'mb-5' : 'mb-0'} mt-1 flex flex-col items-center justify-between sm:mt-0`}
    >
      {match && isGameMakerMatch(match) ? (
        <GameMakerHeader match={match} />
      ) : (
        <>
          <h2 className='text-center text-xl font-bold text-white sm:text-3xl'>
            {match?.tournament_title}
          </h2>
          <h3 className='my-1 flex flex-col gap-1 text-center font-bold text-white sm:flex-row sm:gap-10 sm:text-2xl'>
            <span>{match?.event_title}</span>
          </h3>
        </>
      )}
    </div>
  );
}

export default MatchHeader;
